const videos = document.querySelectorAll('.text-video-container video, .stockist-wrapper video');

if (videos) {
    videos.forEach((video) => {
        const play = video.nextElementSibling.querySelector('svg.play');
        const overlay = video.nextElementSibling;
        const pause_overlay = video.nextElementSibling.querySelector('.pause-video');
        const video_overlay_play = video.nextElementSibling.querySelector('.play-video');
        const video_img = video.nextElementSibling.querySelector('img');
        
        if (play) {
            play.addEventListener('click', () => {
                video.play();
                overlay.classList.add('pause');
                video_overlay_play.style.display = 'none';
                video_img.style.display = 'none';
                pause_overlay.style.display = 'block';
            })
        }
        
        if (pause_overlay) {
            pause_overlay.addEventListener('click', () => {
                video.pause();
                pause_overlay.style.display = 'none';
                video_overlay_play.style.display = 'block';
            })
        }
    });
}
